//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Section.js";
import "../Features/Features.SheetMetal.CornerTreatmentBuilder.js";
import "../no/SelectFace.js";
import "../no/SelectEdge.js";
import "../no/ugmath.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/Features.js";
let d=[[[1,"AddedGeometry",0,"Section",0],[0,"Associative",1,0],[0,"AutoAssignComponentLayer",1,0],[0,"AutoAssociateObjects",1,0],[0,"FixAtTimestamp",1,0],[0,"FlatBodyColor",1,0],[0,"FlatBodyLayer",1,0],[1,"InnerCornerTreatment",0,"Features.SheetMetal.CornerTreatmentBuilder",0],[0,"LayerSetting",1,0],[0,"Orientation",1,0],[0,"OrientationCsys",1,"CoordinateSystem",0],[1,"OuterCornerTreatment",0,"Features.SheetMetal.CornerTreatmentBuilder",0],[0,"ReferenceVertex",1,0],[1,"StationaryFace",0,"SelectFace",0],[0,"TransformComponents",1,0],[0,"TransformPinAndCCP",1,0],[0,"TransformRestrictionAreas",1,0],[0,"TransformToAbsoluteCsys",1,0],[1,"XAxisEdge",0,"SelectEdge",0]],[[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.FlatSolidBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.FlatSolidBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.FlatSolidBuilder.OrientationType = Object.freeze({
    "Default" : "Default", "Edge" : "Edge", "Csys" : "Csys"});

SPLM.Features.SheetMetal.FlatSolidBuilder.TransformComponentsOption = Object.freeze({
    "None" : "None", "Body" : "Body", "Csys" : "Csys", "BodyAndComponent" : "BodyAndComponent"});

SPLM.Features.SheetMetal.FlatSolidBuilder.LayerSettingOption = Object.freeze({
    "Default" : "Default", "Preference" : "Preference", "Specify" : "Specify"});

export default SPLM;